module.exports = __webpack_public_path__ + "img/5.dce6510b.jpg";